import {CsvModel} from "../../util/CSVWriteUtil";
import {DeskRef} from "../../api/Model";
import {VisitWithAssignedDesksStats} from "../../components/visit-stat-block/OfficeVisitStats";

export type ExportNeighbourhoodVisitStats = VisitWithAssignedDesksStats & {
    neighbourhood: {name: string, desks: DeskRef[]}
};

type ExportNeighbourhoodVisitRow = ExportNeighbourhoodVisitStats & {
    visitsByDate: Map<string, number>,
};

function visitDateColumns(rows: ExportNeighbourhoodVisitStats[]) {
    return Array.from(new Set(rows.flatMap(row => row.visits.map(visit => visit.date))))
        .sort();
}

function percent(value: number) {
    return `${value.toFixed()}%`;
}

export function downloadNeighbourhoodVisitCsv(rows: ExportNeighbourhoodVisitStats[], filenamePrefix = 'neighbourhood_visits') {
    const dates = visitDateColumns(rows);
    const model = new CsvModel<ExportNeighbourhoodVisitRow>([
        {
            header: 'Neighbourhood',
            value: row => row.neighbourhood.name,
        },
        {
            header: 'Desks',
            value: row => row.neighbourhood.desks.length.toString(),
        },
        {
            header: 'Members',
            value: row => row.employeeStats.employees.length.toString(),
        },
        {
            header: 'Assign recommended',
            value: row => row.employeeStats.assignedDeskRecommendationEmployees.size.toString(),
        },
        ...dates.map(date => ({
            header: date,
            value: (row: ExportNeighbourhoodVisitRow): string => (row.visitsByDate.get(date) || 0).toString(),
        })),
        {
            header: 'Avg',
            value: row => row.avgVisits.value.toString(),
        },
        {
            header: 'Avg %',
            value: row => percent(row.avgVisits.percent),
        },
        {
            header: 'Median',
            value: row => row.median.value.toString(),
        },
        {
            header: 'Median %',
            value: row => percent(row.median.percent),
        },
        {
            header: 'P90',
            value: row => row.percentile90.value.toString(),
        },
        {
            header: 'P90 %',
            value: row => percent(row.percentile90.percent),
        },
        {
            header: 'Max',
            value: row => row.maxVisits.value.toString(),
        },
        {
            header: 'Max %',
            value: row => percent(row.maxVisits.percent),
        },
        {
            header: 'Overflow days',
            value: row => row.overflowDays.toString(),
        },
    ]);

    const date = new Date();
    model.downloadCsv(
        `${filenamePrefix}_${date.toISOString()}.csv`,
        rows.map(row => ({
            ...row,
            visitsByDate: new Map(row.visits.map(visit => [visit.date, visit.visitorCount])),
        })),
    );
}
